<template>
	<div class="md-layout md-gutter">
		<div class="md-layout-item">
			<md-card>
				<md-card-header class="md-card-header-icon md-card-header-blue">
					<div class="md-layout">
						<div class="md-layout-item">
							<div class="card-icon">
								<font-awesome-icon class="md-icon" :icon="['fa', 'stream']" />
							</div>
							<h4 class="title">Liste des sites - <span class="font-medium">Appatage non permanent</span></h4>
						</div>
					</div>
				</md-card-header>
				<md-card-content>
					<div>
						<span class="font-bold">Filtres</span>
					</div>
					<div class="flex items-center justify-between mb-2">
						<div class="checkbox-filter">
							<md-checkbox v-model="filter.isSmart" class="mb-0 mt-2">SMART</md-checkbox>
						</div>
						<div class="flex items-center space-x-4">
							<md-button class="md-success md-icon-button md-raised my-auto" @click="getSites">
								<font-awesome-icon class="md-icon" :icon="['fa', 'filter']" />
								<span class="font-medium ml-2 leading-none">Filtrer</span>
							</md-button>
							<md-button class="md-default md-icon-button md-raised my-auto" @click="resetFilters">
								<font-awesome-icon class="md-icon" :icon="['fa', 'times-circle']" />
								<span class="font-medium ml-2 leading-none">Réinitialiser</span>
							</md-button>
						</div>
					</div>
					<div class="flex items-center justify-between">
						<div>
							<span class="font-medium">{{ `Total : ${this.pagination.total} sites` }}</span>
						</div>
						<div style="min-width: 200px;">
							<div class="md-multiselect">
								<label>Éléments à afficher</label>
								<multiselect v-model="pagination.perPage"
								             :options="pagination.perPageOptions"
								             :searchable="false"
								             :show-labels="false"
								             :allow-empty="false">
									<template slot="noOptions">La liste est vide</template>
									<template slot="noResult">Aucun élement correspondant</template>
								</multiselect>
							</div>
						</div>
					</div>
					<div class="relative" style="min-height: 250px;">
						<md-table :value="sites" class="paginated-table" table-header-color="blue">
							<md-table-row v-if="sites.length > 0" slot="md-table-row" slot-scope="{ item }">
								<md-table-cell md-label="Client" style="max-width: 250px; width: 250px;">
									<span class="font-medium cursor-pointer hover:underline" @mousedown="goToRoute($event, 'Client Details', { id: item.client_id })">
										{{ item.client_name }}
									</span>
								</md-table-cell>
								<md-table-cell md-label="Site" style="max-width: 350px; width: 350px;">
									<span class="font-medium cursor-pointer hover:underline" @mousedown="goToRoute($event, 'Site Details', { id: item.client_id, idSite: item.id })">
										{{ item.name }}
									</span>
								</md-table-cell>
								<md-table-cell md-label="Activité">{{ item.activity_name }}</md-table-cell>
								<md-table-cell md-label="Secteur">{{ item.sector_name }}</md-table-cell>
								<md-table-cell md-label="SMART" style="max-width: 25px;">
									<div :class="item.is_smart ? 'text-success' : 'text-danger'">
										<font-awesome-icon class="md-icon" style="min-width: 14px; max-width: 18px;" :icon="['fa', item.is_smart ? 'check' : 'times']" />
									</div>
								</md-table-cell>
							</md-table-row>
							<md-table-empty-state v-if="!loading"
							                      md-label="Pas de sites trouvés"
							                      md-description="Essayez une recherche différente">
							</md-table-empty-state>
						</md-table>
						<div v-if="loading" class="loader-overlay opacity-100 absolute z-50 w-full h-full">
							<div class="h-full w-full flex items-center justify-center">
								<md-progress-spinner class="md-white" md-mode="indeterminate"
								                     :md-diameter="50" :md-stroke="4"></md-progress-spinner>
							</div>
						</div>
					</div>
				</md-card-content>
				<md-card-actions md-alignment="space-between">
					<p class="card-category">
						Affichage des éléments {{ from + 1 }} à {{ to }} sur {{ pagination.total }} éléments
					</p>
					<pagination
						class="pagination-no-border pagination-info"
						v-model="pagination.currentPage"
						:per-page="pagination.perPage"
						:total="pagination.total"
						@input="getSites">
					</pagination>
				</md-card-actions>
			</md-card>
		</div>
	</div>
</template>

<script>
import { Pagination } from "@/components";

import routerMixin from "../../mixins/router-mixin";
export default {
	name: "Sites",
	components: {
		Pagination
	},
	mixins: [routerMixin],
	data() {
		return {
			sites: [],
			filter: {
				isSmart: false
			},
			pagination: {
				perPage: 50,
				currentPage: 1,
				perPageOptions: [50, 100, 200],
				total: 0
			},
			loading: true
		}
	},
	computed: {
		to() {
			let highBound = this.from + this.pagination.perPage;
			if (this.pagination.total < highBound) {
				highBound = this.pagination.total;
			}
			return highBound;
		},
		from() {
			return this.pagination.perPage * (this.pagination.currentPage - 1);
		},
	},
	methods: {
		async getSites() {
			this.loading = true

			const response = await this.$store.dispatch('sites/getSites', {
				page: this.pagination.currentPage,
				perPage: this.pagination.perPage,
				is_smart: this.filter.isSmart
			})
			this.sites = response.data.data
			this.pagination.total = response.data.total
			this.loading = false
		},
		resetFilters() {
			this.filter.isSmart = false

			this.getSites()
		}
	},
	mounted() {
		this.getSites()
	}
}
</script>

<style scoped>

</style>
